import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _get from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/get.js";
import _inherits from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import { Array as ArrayT } from './Array.js';
import { Number as NumberT } from './Number.js';
import * as utils from './utils.js';
export var LazyArray = /*#__PURE__*/function (_ArrayT) {
  _inherits(LazyArray, _ArrayT);
  var _super = _createSuper(LazyArray);
  function LazyArray() {
    _classCallCheck(this, LazyArray);
    return _super.apply(this, arguments);
  }
  _createClass(LazyArray, [{
    key: "decode",
    value: function decode(stream, parent) {
      var pos = stream.pos;
      var length = utils.resolveLength(this.length, stream, parent);
      if (this.length instanceof NumberT) {
        parent = {
          parent: parent,
          _startOffset: pos,
          _currentOffset: 0,
          _length: length
        };
      }
      var res = new LazyArrayValue(this.type, length, stream, parent);
      stream.pos += length * this.type.size(null, parent);
      return res;
    }
  }, {
    key: "size",
    value: function size(val, ctx) {
      if (val instanceof LazyArrayValue) {
        val = val.toArray();
      }
      return _get(_getPrototypeOf(LazyArray.prototype), "size", this).call(this, val, ctx);
    }
  }, {
    key: "encode",
    value: function encode(stream, val, ctx) {
      if (val instanceof LazyArrayValue) {
        val = val.toArray();
      }
      return _get(_getPrototypeOf(LazyArray.prototype), "encode", this).call(this, stream, val, ctx);
    }
  }]);
  return LazyArray;
}(ArrayT);
var LazyArrayValue = /*#__PURE__*/function () {
  function LazyArrayValue(type, length, stream, ctx) {
    _classCallCheck(this, LazyArrayValue);
    this.type = type;
    this.length = length;
    this.stream = stream;
    this.ctx = ctx;
    this.base = this.stream.pos;
    this.items = [];
  }
  _createClass(LazyArrayValue, [{
    key: "get",
    value: function get(index) {
      if (index < 0 || index >= this.length) {
        return undefined;
      }
      if (this.items[index] == null) {
        var pos = this.stream.pos;
        this.stream.pos = this.base + this.type.size(null, this.ctx) * index;
        this.items[index] = this.type.decode(this.stream, this.ctx);
        this.stream.pos = pos;
      }
      return this.items[index];
    }
  }, {
    key: "toArray",
    value: function toArray() {
      var result = [];
      for (var i = 0, end = this.length; i < end; i++) {
        result.push(this.get(i));
      }
      return result;
    }
  }]);
  return LazyArrayValue;
}();